import { gql } from '@apollo/client';

export const updateMember = gql`
  mutation updateMember($input: UpdateMemberInput!) {
    updateMember(input: $input) {
      user {
        id
        cognito {
          enabled
          status
        }
        invitations {
          invitedDate
          organization {
            id
            name
          }
          role
          status
        }
        memberships {
          role
          organization {
            name
          }
        }
        subscriptions {
          expirationDate
          validFrom
          product {
            name {
              value
              languageId
              languageCode
            }
          }
        }
      }
    }
  }
`;
export const deleteUser = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
    }
  }
`;
